import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getParameters () {
   return Api().get("/parameters");
},
  updateParameter (params) {
    return Api().put("/parameters",params);
  },
  addParameter (params) {
    return Api().post("/parameters",params);
  },
  getParameter (params) {
    return Api().get("/parameters/"+params);
  },
  deleteParameter (params) {
    return Api().delete("/parameters/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/ParameterService.js